import { render, staticRenderFns } from "./FormPOI.vue?vue&type=template&id=9039b8b2&scoped=true"
import script from "./FormPOI.vue?vue&type=script&lang=js"
export * from "./FormPOI.vue?vue&type=script&lang=js"
import style0 from "./FormPOI.vue?vue&type=style&index=0&id=9039b8b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9039b8b2",
  null
  
)

export default component.exports